import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getProjectsGroupedByCapability } from '../utils/dataModel';
import ProjectLogo from './ProjectLogo';
import SEO from './SEO';

const WorkListPage = () => {
  const groupedProjects = getProjectsGroupedByCapability();
  const { hash } = useLocation();

  // Honour #capability-id anchors coming from the homepage cards; otherwise start at the top.
  useEffect(() => {
    if (hash) {
      const target = document.getElementById(hash.slice(1));
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [hash]);

  return (
    <>
      <SEO
        title="Client Work | Alek Hagopian"
        description="Client engagements across data and analytics engineering, applied AI and machine learning, and productization — for Crain Communications, Hart Energy, Mastercard, Insurity, and others."
      />

      <div className="projects-list-page">
        <div className="projects-header">
          <div className="container">
            <div className="project-breadcrumb">
              <Link to="/">Home</Link>
              <span> / </span>
              <span>Work</span>
            </div>

            <div className="projects-header-content">
              <h1>Client Work</h1>
              <p className="projects-subtitle">
                Engagements I've delivered, grouped by the kind of problem they were.
                Each one leads with the result, then what was actually broken.
              </p>
            </div>
          </div>
        </div>

        <div className="projects-content">
          <div className="container">
            {groupedProjects.map(({ capability, projects }) => (
              <section
                key={capability.id}
                id={capability.id}
                className="service-projects-section"
              >
                <div className="service-section-header">
                  <h2>
                    <span className="capability-glyph-inline" aria-hidden="true">
                      {capability.icon}
                    </span>
                    {capability.title}
                  </h2>
                  <p className="service-description">{capability.description}</p>
                </div>

                <div className="projects-grid">
                  {projects.map((project) => (
                    <Link
                      to={`/work/${project.id}`}
                      key={project.id}
                      className="project-card-link"
                    >
                      <div className="project-card">
                        <div className="project-logo">
                          <ProjectLogo project={project} />
                        </div>
                        <h3>{project.title}</h3>
                        <p className="project-client">{project.client_name}</p>
                        {project.headline_outcome && (
                          <p className="project-outcome">{project.headline_outcome}</p>
                        )}
                        <p className="project-summary">{project.problem_statement}</p>
                        <span className="project-link-text">View project →</span>
                      </div>
                    </Link>
                  ))}
                </div>
              </section>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default WorkListPage;
